import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Flex, Form, Input, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormItem } from '../../../components/form-item'
import { CustomAttributeRow } from './types'

type CampaignCustomAttributesSectionProps = {
    attributeRows?: CustomAttributeRow[]
}

export function CampaignCustomAttributesSection({ attributeRows }: CampaignCustomAttributesSectionProps) {
    const { t } = useTranslation()

    return (
        <FormItem>
            {attributeRows && attributeRows.length > 0 && (
                <Flex
                    gap="small"
                    align="center"
                    className="flex-col sm:flex-row mb-2"
                >
                    <div className="w-full">
                        <Typography.Text>{t('Key')}</Typography.Text>
                    </div>
                    <div className="w-full">
                        <Typography.Text>{t('Value')}</Typography.Text>
                    </div>
                    <div className="min-w-12" />
                </Flex>
            )}
            <Form.List name="customAttributeRows">
                {(fields, { add, remove }) => (
                    <Flex
                        vertical
                        gap="middle"
                    >
                        {fields.map((field) => (
                            <Flex
                                key={field.key}
                                gap="small"
                                align="center"
                                className="flex-col sm:flex-row"
                            >
                                <div className="w-full">
                                    <FormItem
                                        name={[field.name, 'key']}
                                        noStyle
                                    >
                                        <Input placeholder={t('e.g. external_id')} />
                                    </FormItem>
                                </div>
                                <div className="w-full">
                                    <FormItem
                                        name={[field.name, 'value']}
                                        noStyle
                                    >
                                        <Input placeholder={t('e.g. zap-123')} />
                                    </FormItem>
                                </div>
                                <Button
                                    className="min-w-12"
                                    aria-label={t('Remove attribute')}
                                    title={t('Remove attribute')}
                                    icon={<DeleteOutlined />}
                                    onClick={() => remove(field.name)}
                                />
                            </Flex>
                        ))}
                        <Button
                            block
                            icon={<PlusOutlined />}
                            onClick={() => add({ key: '', value: '' })}
                        >
                            {t('Add custom attribute')}
                        </Button>
                    </Flex>
                )}
            </Form.List>
        </FormItem>
    )
}
